module.exports = __webpack_public_path__ + "img/20191226153913807.35b8f0fb.jpg";